import { useState } from "react";
import { motion, useInView } from "framer-motion";

import { MainPageWrap } from "../../wrapper";
import { urlFor, client } from "../../client";

import "./About.scss";
import { useEffect } from "react";
import { useRef } from "react";
import { sectionVariants } from "../../utils/animation";

const About = ({ handleActiveIndex }) => {
  const [abouts, setAbouts] = useState();
  const aboutRef = useRef();
  const isInView = useInView(aboutRef);

  useEffect(() => {
    if (isInView) {
      handleActiveIndex(1);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInView]);

  const featureAnimation = {
    hidden: {
      x: 100,
      opacity: 0,
      scale: 0,
    },
    visible: (custom) => ({
      x: 0,
      scale: [1.3, 1],
      opacity: 1,
      transition: { delay: (custom / 2) * 0.2, duration: 0.2 },
    }),
  };

  const fetchAbouts = async (aboutsQuery) => {
    try {
      const response = await client.fetch(aboutsQuery);
      const data = await response;
      setAbouts(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const query = '*[_type == "abouts"]';
    fetchAbouts(query);
  }, []);

  return (
    <motion.div
      ref={aboutRef}
      initial="hidden"
      whileInView="visible"
      variants={sectionVariants}
      viewport={{ once: true }}
      className="about"
    >
      <h2 className="about__title title">
        I Know That <span>Good Development</span>
        <br />
        Means <span>Good Business</span>
      </h2>
      <div className="about__profession professions">
        {abouts &&
          abouts.map((about, index) => (
            <motion.div
              initial="hidden"
              whileInView="visible"
              custom={index + 1}
              variants={featureAnimation}
              className="proffesions__item"
              key={about.title + index}
            >
              <img src={urlFor(about.imgUrl)} alt={about.title} />
              <h2 className="professions__title">{about.title}</h2>
              <p className="p-text">{about.description}</p>
            </motion.div>
          ))}
      </div>
    </motion.div>
  );
};

export default MainPageWrap(About, "about", "white-bg");
